import React from 'react';
import { Icon, Stack, Strong } from '@ovotech/element-v5';
import { Fuel, TopupHistoryItem } from '@/src/api/payg/types';
import { ASC_LABEL } from '@/src/components/payg/utils/topupCopy';
import { formatShortDate, formatTime } from '@/src/utils/date';
import {
  formatTopupAmount,
  getTopupPresentation,
} from '@/src/pages/PAYGTopupHistory/utils';
import {
  Amount,
  DateLine,
  FuelIcon,
  Heading,
  HeadingGroup,
  StatusLabel,
  TopRow,
  TopupType,
} from './TopupDetailHeader.styled';

type Props = {
  item: TopupHistoryItem;
  fuel: Fuel;
};

export const TopupDetailHeader = ({ item, fuel }: Props) => {
  const { statusLabel, statusVariant, showPlus } = getTopupPresentation(item);
  const amount = `${showPlus ? '+' : ''}${formatTopupAmount(
    item.amountInPence,
  )}`;

  return (
    <Stack spaceBetween={6}>
      <TopRow>
        <HeadingGroup>
          <FuelIcon>
            <Icon name={fuel === Fuel.GAS ? 'gas' : 'electricity'} size={24} />
          </FuelIcon>
          <div>
            <Heading semanticComponent="h1">{fuel} top-up</Heading>
            {item.topupType === 'asc' && <TopupType>{ASC_LABEL}</TopupType>}
            {statusLabel && statusVariant && (
              <StatusLabel $variant={statusVariant}>{statusLabel}</StatusLabel>
            )}
          </div>
        </HeadingGroup>
        <Amount>
          <Strong>{amount}</Strong>
        </Amount>
      </TopRow>
      <DateLine>{`${formatShortDate(item.transactionDateTime)} · ${formatTime(
        item.transactionDateTime,
      )}`}</DateLine>
    </Stack>
  );
};
